import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


export function pointsGsap() {
    document.addEventListener('DOMContentLoaded', function () {

        const mainWrapper = document.querySelector('.blockPointsSlider__wrapper');
        const navWrapper = document.querySelector('.blockPointsSlider__wysiwyg');
        const navWrapper2 = document.querySelector('.blockPointsSlider__slide-line');

        ScrollTrigger.create({
            trigger: navWrapper,
            start: 'top top',
            end: 'bottom 50%',
            endTrigger: mainWrapper,
            pinSpacing: false,
            pin: navWrapper,
            // markers: true,
            scrub: true,
        })

        ScrollTrigger.create({
            trigger: navWrapper,
            start: 'top top',
            end: 'bottom 50%',
            endTrigger: mainWrapper,
            pinSpacing: false,
            pin: navWrapper2,
            // markers: true,
            scrub: true,
        })

        const mediaBoxes = document.querySelectorAll('.blockPointsSlider__slide');

        mediaBoxes.forEach(element => {
            gsap.fromTo(element, { opacity: 0, blur: 10 }, {
                opacity: 1, blur: 0, stagger: 0.2, duration: 1, ease: 'easeInOut', scrollTrigger: {
                    trigger: element,
                    start: 'top bottom',
                    end: 'top center-=20%',
                    // start: '50% bottom',
                    scrub: true,
                }
            });
        })


    });
};

export function pointsSlider() {
    document.addEventListener('DOMContentLoaded', function () {
        const pointsSlider = document.querySelectorAll('.blockPointsSlider .splide');

        if (!pointsSlider) return;

        pointsSlider.forEach(slider => {
            const splideSlider = new window.splide(slider, {
                type: 'loop',
                direction: 'ttb',
                height: '700px',
                // height: 'auto',
                wheel: true,
                pagination: false,
                arrows: false,

                breakpoints: {
                    991: {
                        direction: 'ltr',
                        height: 'auto',
                        pagination: true,
                    },
                },
            })

            splideSlider.mount();
        });

    });
};